(() => {
  function init(root = document) {
    const popup = root.querySelector('[data-newsletter-popup]');
    if (!popup || popup.dataset.ready) return;
    popup.dataset.ready = 'true';
    const card = popup.querySelector('[role=dialog]');
    const form = popup.querySelector('form');
    const success = popup.querySelector('[data-newsletter-success]');
    const errors = popup.querySelector('[data-newsletter-error]');
    const key = 'hp-newsletter-v1';
    let timer, returnFocus, previousOverflow, inertNodes = [], cancelled = false;
    const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
    const remember = (subscribed = false) => {
      if (window.Shopify?.designMode) return;
      try { localStorage.setItem(key, JSON.stringify({ subscribed: subscribed || read().subscribed === true, until: Date.now() + Number(popup.dataset.dismissDays || 30) * 86400000 })); } catch { /* Signup and dismissal still work when storage is unavailable. */ }
    };
    const suppressed = () => { const saved = read(); return popup.dataset.subscribed === 'true' || saved.subscribed || saved.until > Date.now(); };
    const busy = () => {
      const shipping = document.querySelector('[data-cart-drawer]');
      const otherDialog = [...document.querySelectorAll('[aria-modal=true]:not(.newsletter-popup__card), .mobile-drawer.is-open')].some(node => node.getClientRects().length && !node.closest('[hidden]'));
      return (shipping && !shipping.hidden) || otherDialog || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName);
    };
    function open() {
      if (!popup.hidden) return;
      clearTimeout(timer);
      returnFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      // Keep third-party CAPTCHA overlays operable; only the storefront regions become inert.
      inertNodes = [...document.querySelectorAll('body > header, body > main, body > footer, body > .shopify-section')].filter(node => !node.contains(popup) && !node.inert);
      inertNodes.forEach(node => { node.inert = true; });
      document.body.style.overflow = 'hidden';
      popup.hidden = false;
      document.dispatchEvent(new CustomEvent('newsletter:opened'));
      (success || errors || card).focus({ preventScroll: true });
    }
    function close() {
      if (popup.hidden) return;
      popup.hidden = true;
      document.body.style.overflow = previousOverflow;
      inertNodes.forEach(node => { node.inert = false; });
      inertNodes = [];
      remember(!!success);
      cancelled = true;
      clearTimeout(timer);
      if (returnFocus?.isConnected && returnFocus !== document.body && returnFocus.getClientRects().length) returnFocus.focus({ preventScroll: true });
    }
    const schedule = () => {
      if (cancelled || suppressed() || window.Shopify?.designMode) return;
      if (document.hidden || busy()) { timer = setTimeout(schedule, 2000); return; }
      open();
    };
    const onOpenClick = event => { if (event.target.closest('[data-newsletter-open]')) open(); };
    const onCart = event => { if (event.detail?.source === 'add') { cancelled = true; clearTimeout(timer); } };
    const onProductSubmit = event => { if (event.target.matches('[data-product-form]')) { cancelled = true; clearTimeout(timer); } };
    const onKey = event => {
      if (popup.hidden) return;
      if (event.key === 'Escape' && popup.contains(event.target)) { event.preventDefault(); close(); }
      if (event.key !== 'Tab' || !popup.contains(event.target)) return;
      const targets = [...card.querySelectorAll('button:not(:disabled), input:not([type=hidden]), a[href], [tabindex="0"]')].filter(node => node.getClientRects().length);
      const first = targets[0], last = targets[targets.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === card || document.activeElement === success || document.activeElement === errors)) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    };
    popup.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', close));
    popup.addEventListener('click', event => { if (event.target === popup) close(); });
    // Native Shopify POST preserves spam protection and the server-confirmed success/error state.
    form?.addEventListener('submit', () => { cancelled = true; clearTimeout(timer); });
    document.addEventListener('click', onOpenClick);
    document.addEventListener('keydown', onKey);
    document.addEventListener('cart:updated', onCart);
    document.addEventListener('submit', onProductSubmit, true);
    const section = popup.closest('.shopify-section');
    section?.addEventListener('shopify:section:select', open);
    section?.addEventListener('shopify:section:deselect', close);
    section?.addEventListener('shopify:section:unload', () => {
      close(); clearTimeout(timer);
      document.removeEventListener('click', onOpenClick);
      document.removeEventListener('keydown', onKey);
      document.removeEventListener('cart:updated', onCart);
      document.removeEventListener('submit', onProductSubmit, true);
    }, { once: true });
    if (success) remember(true);
    if (success || errors || new URLSearchParams(location.search).get('newsletter') === 'preview') open();
    else if (popup.dataset.auto === 'true') timer = setTimeout(schedule, Number(popup.dataset.delay || 8) * 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
